import { Button, Input, Stack } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { useState } from 'react';

import { useCurrentDraft } from '../../hooks/useCurrentDraft';

/**
 * Sticky footer with discard/delete. Owns the confirm mini-flows; the parent remounts this (key={draft.id}) so the
 * flows reset when the draft changes.
 */
export const DraftActionBar = () => {
  const { draft, isDiscarding, isDeleting, discardDraft, deleteDraft } = useCurrentDraft();

  const [showDiscardReason, setShowDiscardReason] = useState(false);
  const [discardReason, setDiscardReason] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const isDeletable = !!draft && !draft.is_actionable;
  // No confirmation step is open, so the primary actions are the ones to show.
  const isIdle = !showDiscardReason && !showDeleteConfirm;

  return (
    <Stack px="5" py="3" borderTopWidth="1px" bg="chakra-body-bg" spacing="3">
      <Show if={showDiscardReason}>
        <Input
          placeholder="Discard reason (optional)"
          value={discardReason}
          onChange={(e) => setDiscardReason(e.target.value)}
        />
      </Show>
      <Stack direction="row" spacing="2" justifyContent="flex-end">
        <Show if={isIdle && isDeletable}>
          <Button variant="outline" colorScheme="red" onClick={() => setShowDeleteConfirm(true)}>
            Delete
          </Button>
        </Show>

        <Show if={showDeleteConfirm}>
          <Button variant="ghost" onClick={() => setShowDeleteConfirm(false)}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={deleteDraft} isLoading={isDeleting}>
            Confirm Delete
          </Button>
        </Show>

        <Show if={isIdle}>
          <Button colorScheme="gray" onClick={() => setShowDiscardReason(true)}>
            Discard
          </Button>
        </Show>

        <Show if={showDiscardReason}>
          <Button variant="ghost" onClick={() => setShowDiscardReason(false)}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={() => discardDraft(discardReason)} isLoading={isDiscarding}>
            Confirm Discard
          </Button>
        </Show>
      </Stack>
    </Stack>
  );
};
